import { Endpoint } from '../endpoint';
import {
  TaskId,
  TaskLinkableResponse,
  CreateTaskLinkRequest,
  SearchEntityRequest,
  SearchEntityResponse,
  TaskLinkableId,
} from '@business/entities/task';
import { R } from '@core/utils/r';

export function fetchTaskLinks(taskId: TaskId) {
  return Endpoint.get<TaskLinkableResponse[]>(`@gc/task-links/${taskId}`);
}

export function createTaskLink(data: CreateTaskLinkRequest) {
  return Endpoint.post<TaskLinkableResponse>(`@gc/task-links`, { data });
}

export function deleteTaskLink(taskLinkableId: TaskLinkableId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/task-links/${taskLinkableId}`);
}

export function searchEntities(params: SearchEntityRequest) {
  return Endpoint.get<SearchEntityResponse>(`@gc/task-links/searchable-entities`, {
    params: R.objectCompact(params),
  });
}
